import React from 'react';
import { useTranslation } from 'react-i18next';
import Parser from 'html-react-parser';
import PropTypes from 'prop-types';
import {
  AlertNotice,
} from 'shared/components';
import NextIcon from 'assets/svgs/nextArrow.svg';

const CloseRoomSection = (props) => {
  const { t } = useTranslation();
  return (
    <div className="mt-24">
      <h5>
        {t('taskManagement.closeRoom.title')}
      </h5>
      <div className="border-box-silver close-room-section">
        {props.isClosed ?
          <>
            <AlertNotice message={t('taskManagement.closeRoom.closeCompletedMessage')} type="success"/>
            <button
              className="btn-link btn-edit"
              onClick={props.goToCloseRoomPage}
            >
              {props.isOnline || props.isSpecialTesting ? t('taskManagement.closeRoom.viewClosure') : t('taskManagement.closeRoom.viewEditClosure')}
            </button>
          </> :
          <>
            <p>
              {Parser(t('taskManagement.closeRoom.message'))}
            </p>
            <AlertNotice message={t('taskManagement.closeRoom.warning')} type="warning"
                         noBorder/>
            <button
              className="btn btn-action btn-close ml-0 w-100"
              onClick={props.goToCloseRoomPage}
            >
              <span className="">
                {t('taskManagement.closeRoom.btnLabel')}
              </span>
              <NextIcon />
            </button>
          </>
        }
        
      </div>
    </div>
  );
};

export default CloseRoomSection;

CloseRoomSection.propTypes = {
  goToCloseRoomPage: PropTypes.func,
  isOnline: PropTypes.bool,
  isSpecialTesting: PropTypes.bool,
};
